var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"select-pulldown"},[_vm._t("default"),_c('select-base',{ref:"selectBase",staticClass:"select-pulldown__select",attrs:{"options":_vm.options,"optionDefault":_vm.optionDefault},on:{"change":_vm.changeEvent}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }